
export default{
    weight:[ 
        {
            key : 'sve težine',
            sr : 'sve težine',
            en : 'all weights',
        },
        
    ]
}
